export default {
  CONFIRM: 'notification/CONFIRM',
  DISMISS: 'notification/DISMISS',
  ERROR: 'notification/ERROR',
  SUCCESS: 'notification/SUCCESS',
  PROMPT: 'notification/PROMPT'
};
